module.exports = __webpack_public_path__ + "static/assets/e212820df149647262437de6f986a723.svg";